import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IntegrationPushBackComponent } from 'src/app/features/lt-pushback/components/integration-pushback/integration-pushback.component';
import { IntegrationPushbackAddComponent } from 'src/app/features/lt-pushback/components/integration-pushback-add/integration-pushback-add.component';
import { IntegrationPushbackViewComponent } from 'src/app/features/lt-pushback/components/integration-pushback-view/integration-pushback-view.component';
@NgModule({
  imports: [
    CommonModule,
    IntegrationPushBackComponent,
    IntegrationPushbackAddComponent,
    IntegrationPushbackViewComponent,
  ],
  exports: [
    IntegrationPushBackComponent,
    IntegrationPushbackAddComponent,
    IntegrationPushbackViewComponent,
  ],
})
export class LTPushBackModule { }